import LocalDB from "./localdb";
import Server from "../server";

const LOADED_IDS = "loaded_ids";

const localdb = LocalDB.instance();

export async function addDelivery(id: string) {
    const ids = await getDeliveries();
    if (ids.indexOf(id) == -1) {
        ids.push(id);
    }
    setDeliveries(ids);
}

export async function setDeliveries(ids: string[]) {
    ids = ids.filter((id) => id);
    const content = ids.join(",");
    localdb.set(LOADED_IDS, content);
    Server.instance().recordDeliveryLoad(content);
}

export async function removeDelivery(id: string) {
    const ids = await getDeliveries();
    const ids2 = [];
    for (const i of ids) {
        if (i !== id) {
            ids2.push(i);
        }
    }
    setDeliveries(ids2);
}

export async function getDeliveries() : Promise<string[]> {

    const user = await Server.instance().getUser();
    if (user && user.role === "Casual Delivery") {
        const content = await Server.instance().fetchDeliveryLoad();
        localdb.set(LOADED_IDS, content);
    }

    const ids = (localdb.get(LOADED_IDS) || "").split(/,/).filter((id: any) => id);
    return ids;
}

export async function clearDeliveries() {
    localdb.set(LOADED_IDS, undefined);
}

/**
 * @return true if deliveries need to be updated
 */
export async function checkDeliveries() : Promise<boolean> {

    const user = await Server.instance().getUser();
    if (!user || user.role !== "Casual Delivery") {
        return false;
    }

    const a = await Server.instance().checkDeliveryLoad();
    const b = (localdb.get(LOADED_IDS) || "");

    return a != b;
}
